import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function PhoneNumber({ phoneNumber, setPhoneNumber, inputRef, disabled }) {

  return (
    <PhoneInput
      disabled={disabled}
      country={phoneNumber?.mobileCountryCode || "gb"}
      value={phoneNumber?.mobileNumber || ""}
      onChange={(phone, data) => {
        if (!phone.startsWith("+")) phone = "+" + phone;
        setPhoneNumber({
          ...phoneNumber,
          mobileNumber: phone,
          mobileCountryCode: data.countryCode || phoneNumber?.mobileCountryCode,
          mobileDialCode: data.dialCode || phoneNumber?.mobileDialCode,
        });

    
        if (inputRef?.current) {
          inputRef.current.parentNode.style.border = "";
        }
      }}
      inputProps={{
        name: "mobileNumber",
        required: true,
        placeholder: "Enter mobile number",
        id: "countryPhone",
        className: "form-control react-tel-input",
        style: {
          width: "100% !important",
          border: 'none'
          // height: "calc(3.5rem + calc(var(--bs-border-width) * 2))",
          // minHeight: "calc(3.5rem + calc(var(--bs-border-width) * 2))",
          // lineHeight: "1.25",
        },
        ref: inputRef,
      }}
      containerClass="w-100 react-tel-input-container"
      inputClass="w-100 react-tel-input"
      enableSearch
      
      
    />
  );
}

export default PhoneNumber;
